export const BUILD_ID = 'addday-follow-20261104'
export const APP_ENV = 'PROD'
